import {
  ADD_WEBSITE,
  DEACTIVATE_WEBSITE,
  LOAD_WEBSITES,
  LOAD_WEBSITES_FAIL,
  LOAD_WEBSITES_SUCCESS,
  LoadWebsitesSuccess,
  REMOVE_WEBSITE,
  UPDATE_WEBSITE_DATA_SUCCESS,
  UPDATE_WEBSITE_SCREEN_SHOT,
  UPDATE_WEBSITE_GOOGLE_SCORE,
  UpdateWebsiteDataSuccess,
  UpdateWebsiteScreenShot,
  UpdateWebsiteGoogleScore,
} from '../actions/website.action';
import {
  AddWebsite,
  CLEAR_WEBSITES,
  DeactivateWebsite,
  RemoveWebsite,
  UPDATE_WEBSITE_WORDPRESS_VERSION,
  UpdateWebsiteWordpressVersion,
  WebsiteAction
} from "../actions";

export interface IWebsiteState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IWebsiteState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IWebsiteState = initialState, action: WebsiteAction): IWebsiteState {
  let payload: any;

  switch (action.type) {

    case LOAD_WEBSITES:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_WEBSITES_SUCCESS:
      payload = (<LoadWebsitesSuccess>action).payload;

      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_WEBSITES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case UPDATE_WEBSITE_DATA_SUCCESS:
      const updatedWebsite: any = (<UpdateWebsiteDataSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [updatedWebsite.id]: updatedWebsite
        }
      };

    case ADD_WEBSITE:
      const addedWebsite: any = (<AddWebsite>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [addedWebsite.id]: addedWebsite
        }
      };

    case UPDATE_WEBSITE_SCREEN_SHOT:
      payload = (<UpdateWebsiteScreenShot>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            screenshot: payload.screenshot
          }
        }
      };

    case UPDATE_WEBSITE_GOOGLE_SCORE:
      payload = (<UpdateWebsiteGoogleScore>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            score: payload.score ? {current_score: payload.score.current_score, previous_score: payload.score.previous_score, original_score: (state.entities[payload.websiteId] && state.entities[payload.websiteId].score && state.entities[payload.websiteId].score.original_score) ? state.entities[payload.websiteId].score.original_score : null} : {current_score: null, previous_score: (state.entities[payload.websiteId] && state.entities[payload.websiteId].score && state.entities[payload.websiteId].score.previous_score) ? state.entities[payload.websiteId].score.previous_score : null, original_score: (state.entities[payload.websiteId] && state.entities[payload.websiteId].score && state.entities[payload.websiteId].score.original_score) ? state.entities[payload.websiteId].score.original_score : null}
          }
        }
      };

    case DEACTIVATE_WEBSITE:
      const deactivatedWebsite: any = (<DeactivateWebsite>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [deactivatedWebsite.id]: deactivatedWebsite
        }
      };

    case REMOVE_WEBSITE:
      const removedWebsite: number = (<RemoveWebsite>action).payload;
      const websitesMap = {...state.entities};
      delete websitesMap[removedWebsite];

      return {
        ...state,
        entities: websitesMap
      };

    case UPDATE_WEBSITE_WORDPRESS_VERSION:
      payload = (<UpdateWebsiteWordpressVersion>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            platform_version: payload.wordpressVersion
          }
        }
      };

    case CLEAR_WEBSITES:
      return {
        ...state,
        entities: {},
        loading: false,
        loaded: false
      };

  }

  return state;
}
